import { render } from "./StoreSelector.vue?vue&type=template&id=80d6a5e0"
import script from "./StoreSelector.vue?vue&type=script&lang=js"
export * from "./StoreSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__